var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 12.9048C10.3488 12.9048 8.19971 10.7726 8.19971 8.14286V5.7619C8.19971 3.13214 10.3488 1 12.9995 1C15.6501 1 17.7992 3.13214 17.7992 5.7619V8.14286C17.7992 10.7726 15.6501 12.9048 12.9995 12.9048Z",
    stroke: "#888888",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39283 14.0952C8.67602 14.0952 8.928 14.2452 9.0924 14.475C9.96115 15.6905 11.3855 16.4762 12.9994 16.4762C14.6133 16.4762 16.0376 15.6905 16.9064 14.475C17.0708 14.2452 17.3216 14.0952 17.606 14.0952H17.6084C21.6906 14.0952 25 17.3785 25 21.4285V24.7738C25 25.4512 24.4468 26 23.7641 26H2.23594C1.55317 26 1 25.4512 1 24.7738V21.4285C1 17.3785 4.31063 14.0952 8.39283 14.0952Z",
    stroke: "#888888",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.90eaed60d7ba5237c8ad9787311383fd.svg";
export { ForwardRef as ReactComponent };